import { API } from "../auth/authApi";

export const getChatConversationsApi = (params) => {
    return API.get("/chat/conversation/admin", { params });
};

export const getChatMessagesApi = (conversationId, params) => {
    return API.get(`/chat/conversation/${conversationId}/message`, { params });
};